module.exports = __webpack_public_path__ + "img/icon-run-active.c604c4f9.svg";